import 'react';
import PropTypes$1 from 'prop-types';
import { useValue } from '@morningtrain/react-resources';
import { observer } from 'mobx-react';
import moment$1 from 'moment';

function DateTime(props) {
  var name = props.name,
      defaultValue = props.defaultValue;
  var value = useValue(name, defaultValue);

  if (!value) {
    return null;
  }

  value = moment$1(value, props.parseFormat);

  if (!value) {
    return null;
  }

  return value.format(props.dateFormat + ' ' + props.timeFormat);
}

DateTime.defaultProps = {
  defaultValue: null,
  dateFormat: 'DD.MM.YYYY',
  timeFormat: 'HH:mm',
  parseFormat: "YYYY-MM-DD HH:mm:ss ZZ"
};
DateTime.propTypes = {
  name: PropTypes$1.string.isRequired,
  defaultValue: PropTypes$1.any,
  dateFormat: PropTypes$1.string,
  timeFormat: PropTypes$1.string,
  parseFormat: PropTypes$1.string
};
var DateTime$1 = observer(DateTime);

export default DateTime$1;
//# sourceMappingURL=DateTime.js.map
